<div>
  <div class="container-fluid">
    <div class="row">
      <div class="col-sm-12 col-md-8">
        <app-advance-line [step]="step" [currentStep]="currentStep"></app-advance-line>
        <br>
        <h3 class="h3-tipografia-govco" *ngIf="!showResumeRequestSaved">Trámite: {{ procedureTitle }}</h3>
        <br>
        <p class="text2-tipografia-govco" *ngIf="!showResumeRequestSaved">{{ procedureDescription }}</p>
        <br>
        <br>



        <!--Crear Solicitud-->
        <form role="form" [formGroup]="requestForm" *ngIf="showReqForm && !showResumeRequestSaved">
          <p class="text2-tipografia-govco"><b>¡Respetado(a) Ciudadano(a)!</b> <br>Favor indique a continuación las opciones disponibles para el trámite de Licencia en Seguridad y Salud en el Trabajo!</p>
          <h4 class="h4-tipografia-govco title-1">Información de la solicitud</h4>
          <div class="row">
            <div class="col-sm-12 col-md-12 mb-2">
              <div class="radio-seleccion-govco form-check-inline ms-2 mt-4">
                <input #radioPrimeraVez type="radio" id="radio11" name="processId" formControlName="processId" value="1" (change)="changeTypeTramite('primera')">
                <label for="radio11">Primera Vez</label>
              </div>
              <div class="radio-seleccion-govco form-check-inline ms-2">
                <input #radioModificacion type="radio" id="radio12" name="processId" formControlName="processId" value="2" (change)="changeTypeTramite('modificacion')">
                <label for="radio12">Modificación</label>
              </div>
              <div class="radio-seleccion-govco form-check-inline ms-2">
                <input #radioRenovacion type="radio" id="radio13" name="processId" formControlName="processId" value="3" (change)="changeTypeTramite('renovacion')">
                <label for="radio13">Renovación</label>
              </div>

            </div>

          </div>

          <div class="accordion-govco" id="accordionExampleTwo" *ngIf="ocultarRenovacionBogota == false">

            <div class="item-accordion-govco" *ngIf="showModificationForm==true">
              <h2 class="accordion-header" id="accordionIconoPanels-exampleSix">
                <button class="button-accordion-govco collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#accordionIconoPanels-collapseSix" aria-expanded="false" aria-controls="accordionIconoPanels-collapseSix">
                  <span class="text-button-accordion-govco">
                    <h4 class="h4-tipografia-govco title-1">Seleccione Motivo Modificacion</h4>
                  </span>
                </button>
              </h2>
              <div id="accordionIconoPanels-collapseSix" class="accordion-collapse collapse" aria-labelledby="accordionIconoPanels-exampleSix" data-bs-parent="#accordionExampleTwo">
                <div class="body-accordion-govco">
                  <app-modification [isPersonaJuridica]="showFormPersonaJuridica"></app-modification>
                </div>
              </div>
            </div>


            <div class="item-accordion-govco" *ngIf="showRenewalForm==true">
              <h2 class="accordion-header" id="accordionIconoPanels-exampleFive">
                <button class="button-accordion-govco collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#accordionIconoPanels-collapseFive" aria-expanded="false" aria-controls="accordionIconoPanels-collapseFive">
                  <span class="text-button-accordion-govco title-1">
                    <h4 class="h4-tipografia-govco title-1">Datos adicionales renovación</h4>
                  </span>
                </button>
              </h2>
              <div id="accordionIconoPanels-collapseFive" class="accordion-collapse collapse" aria-labelledby="accordionIconoPanels-exampleFive" data-bs-parent="#accordionExampleTwo">
                <div class="body-accordion-govco">
                  <app-renewal></app-renewal>
                </div>
              </div>
            </div>


            <div class="item-accordion-govco" *ngIf="showFormPersonaJuridica == false">
              <h2 class="accordion-header" id="accordionIconoPanels-exampleTwo">
                <button class="button-accordion-govco collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#accordionIconoPanels-collapseTwo" aria-expanded="false" aria-controls="accordionIconoPanels-collapseTwo">
                  <span class="text-button-accordion-govco title-1">
                    <h4 class="h4-tipografia-govco title-1">Datos Laborales</h4>
                  </span>
                </button>
              </h2>
              <div id="accordionIconoPanels-collapseTwo" class="accordion-collapse collapse" aria-labelledby="accordionIconoPanels-exampleTwo" data-bs-parent="#accordionExampleTwo">
                <div class="body-accordion-govco">
                  <app-labor-data></app-labor-data>
                </div>
              </div>
            </div>

            <div class="item-accordion-govco">
              <h2 class="accordion-header" id="accordionIconoPanels-exampleThree">
                <button class="button-accordion-govco collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#accordionIconoPanels-collapseThree" aria-expanded="false" aria-controls="accordionIconoPanels-collapseThree">
                  <span class="text-button-accordion-govco title-1">
                    <h4 class="h4-tipografia-govco title-1">Tipos de Servicio a Prestar</h4>
                  </span>
                </button>
              </h2>
              <div id="accordionIconoPanels-collapseThree" class="accordion-collapse collapse" aria-labelledby="accordionIconoPanels-exampleThree" data-bs-parent="#accordionExampleTwo">
                <div class="body-accordion-govco">
                  <app-type-service-provide></app-type-service-provide>
                </div>
              </div>
            </div>

            <div class="item-accordion-govco">
              <h2 class="accordion-header" id="accordionIconoPanels-exampleFour">
                <button class="button-accordion-govco collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#accordionIconoPanels-collapseFour" aria-expanded="false" aria-controls="accordionIconoPanels-collapseFour">
                  <span class="text-button-accordion-govco title-1">
                    <h4 class="h4-tipografia-govco title-1">Documentos Adjuntos</h4>
                  </span>
                </button>
              </h2>
              <div id="accordionIconoPanels-collapseFour" class="accordion-collapse collapse" aria-labelledby="accordionIconoPanels-exampleFour" data-bs-parent="#accordionExampleTwo">
                <div class="body-accordion-govco">
                  <app-attachments [isPersonaJuridica]="showFormPersonaJuridica"></app-attachments>
                </div>
              </div>
            </div>
          </div>

          <div class="col-12" style="margin: 5% 0 5% 0; text-align: right">
            <button type="button" class="btn-govco fill-btn-govco" (click)="saveRequest()" [disabled]="sending" *ngIf="ocultarRenovacionBogota==false">Guardar</button>
          </div>
        </form>

        <!-- Pantalla solicitud creada exitosamente -->
        <div *ngIf="showResumeRequestSaved">
          <app-resume-request-saved [numRadicado]="numRadicado"></app-resume-request-saved>
          <div class="p-2">
            <button type="button" class="btn-govco fill-btn-govco"
                    style="margin-right: 10px"
                    (click)="cancelFrm()">Salir</button>
          </div>
        </div>

      </div>

      <div class="col-sm-12 col-md-4">
        <app-service-area></app-service-area>
      </div>
    </div>
  </div>
</div>
